import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { has } from 'lodash';
import { Input } from 'react-toolbox';
import StyledSelect from 'components/StyledSelect';
import CollapsableCard from 'components/CollapsableCard';
import PhaseSurfaceInfoForm from '../../../main/screens/phases/phaseEdit/components/phaseSurfaceInfoForm';
import { error, generateSource } from '../../../../utils';
import cx from 'classnames';
import formStyles from 'styles/form';
import styles from '../refigure';

const largeInput = cx(formStyles.inputs, formStyles.largeInput);
const titleStyle = cx(formStyles.bottomTitle, formStyles.childTitle);

class RefigureCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phase: { sqft: '', surface_information: {}, surface_type: { id: '' } },
      actions: [
        {
          icon: 'delete',
          onClick: (e) => { this.deleteDetails(e); },
        },
      ],
    };
  }

  deleteDetails = () => {
    let phase = this.state.phase;
    phase = { surface_information: {}, surface_type: { id: '' } };
    this.setState({ phase },
      this.props.deleteRefigureDetails(this.props.index));
  }

  handleSurfaceInfoChange = (key, value) => {
    const phase = this.state.phase;
    phase.surface_information = phase.surface_information || {};
    if (key === 'sqft') {
      phase.sqft = value;
    } else {
      phase.surface_information[key] = value;
    }
    this.setState({ phase });
    this.props.updateRefigureDetails(this.props.index, phase);
  }

  handleSurfaceType = (value) => {
    const phase = this.state.phase;
    phase.surface_information = {};
    phase.surface_type.id = value;
    phase.surface_type.value = this.props.surfaceTypes.find(type =>
      type.id === parseInt(value, 10)).name;
    this.setState({ phase });
    this.props.updateRefigureDetails(this.props.index, phase);
  }

  handleAdditionalDetails = (key, value) => {
    const phase = this.state.phase;
    phase[key] = value;
    this.props.updateRefigureDetails(this.props.index, phase);
  }

  handleRoomNameChange = (value) => {
    this.handleAdditionalDetails('roomName', value);
  }
  handleSpecialInstructions = (value) => {
    this.handleAdditionalDetails('specialInstructions', value);
  }

  render() {
    const { surfaceTypes, index, errors } = this.props;
    const { phase } = this.state;
    const refigureError = has(errors, 'refigureDetails') ?
      errors.refigureDetails[index] : {};
    return (
      <div className={styles.RefigureCardWrapper}>
        <CollapsableCard
          title={`Refigure #${index + 1}`}
          actions={this.state.actions}
          headerStyles={styles.collapsableCardHeader}
        >
          <div className={formStyles.divider}>
            <h5 className={titleStyle}>Surface Information</h5>
            <StyledSelect
              className={largeInput}
              label="Surface Type"
              onChange={this.handleSurfaceType}
              options={generateSource(surfaceTypes)}
              value={phase.surface_type.id}
              placeholder={'Select Surface Type'}
              error={error('surface_type', refigureError)}
              required
            />
          </div>
          <PhaseSurfaceInfoForm
            phase={phase}
            surfaceTypes={surfaceTypes}
            onChange={this.handleSurfaceInfoChange}
            onPhaseChange={this.handleSurfaceInfoChange}
          />
          <div className={formStyles.divider}>
            <h5 className={titleStyle}>Additional Details</h5>
            <Input
              label="Room Names"
              className={largeInput}
              value={phase.roomName || ''}
              onChange={this.handleRoomNameChange}
            />
            <Input
              multiline
              label="Special Instructions"
              theme={formStyles}
              value={phase.specialInstructions || ''}
              className={formStyles.textArea}
              onChange={this.handleSpecialInstructions}
            />
          </div>
        </CollapsableCard>
      </div>
    );
  }
}

RefigureCard.propTypes = {
  index: PropTypes.number,
  surfaceTypes: PropTypes.array,
  updateRefigureDetails: PropTypes.func,
  deleteRefigureDetails: PropTypes.func,
  errors: PropTypes.object,
};

export default RefigureCard;



// WEBPACK FOOTER //
// ./client/app/screens/refigure/form/components/refigureCard.jsx